import { apiClient } from '@/lib/api-client'
import { BusinessStatus } from '@shared/types/entities'

export interface CreateBusinessRequest {
  name: string
  address: string
  city: string
  postalCode: string
  areaId: string
  latitude: number
  longitude: number
  category?: string
}

export interface UpdateBusinessRequest {
  name?: string
  address?: string
  city?: string
  postalCode?: string
  category?: string
  status?: BusinessStatus
}

export interface OsmImportResult {
  city: string
  totalFound: number
  imported: number
  skipped: number
  areas: Array<{ name: string; id: string; businessCount: number }>
}

export interface OsmImportJob {
  jobId: string
  status: 'RUNNING' | 'COMPLETED' | 'FAILED'
  city: string
  error?: string
  totalFound?: number
  imported?: number
  skipped?: number
  areas?: Array<{ name: string; id: string; businessCount: number }>
}

export const businessService = {
  importBusinesses: (csvContent: string, token: string) =>
    apiClient.post('/businesses/import', { csvContent }, token),

  importFromOsm: (city: string, regionId: string, cityId: string, token: string) =>
    apiClient.post<OsmImportJob>('/businesses/osm-import', { city, regionId, cityId }, token),

  getOsmImportStatus: (jobId: string, token: string) =>
    apiClient.get<OsmImportJob>(`/businesses/osm-import?jobId=${jobId}`, token),

  listBusinesses: (
    params: { areaId: string; status?: BusinessStatus; limit?: number; nextToken?: string },
    token: string
  ) => {
    const query = new URLSearchParams()
    query.append('areaId', params.areaId)
    if (params.status) query.append('status', params.status)
    if (params.limit) query.append('limit', params.limit.toString())
    if (params.nextToken) query.append('nextToken', params.nextToken)
    return apiClient.get(`/businesses?${query.toString()}`, token)
  },

  getBusiness: (businessId: string, token: string) =>
    apiClient.get(`/businesses/${businessId}`, token),

  updateBusiness: (businessId: string, data: UpdateBusinessRequest, token: string) =>
    apiClient.put(`/businesses/${businessId}`, data, token),

  deleteBusiness: (businessId: string, token: string) =>
    apiClient.delete(`/businesses/${businessId}`, token),

  bulkDeleteByArea: (areaId: string, token: string) =>
    apiClient.post<{ deleted: number; areaId: string }>('/businesses/bulk-delete', { areaId }, token),

  // Phase 4: Scout Operations
  reserveBusiness: (businessId: string, token: string) =>
    apiClient.post(`/businesses/${businessId}/reserve`, {}, token),

  unreserveBusiness: (businessId: string, token: string) =>
    apiClient.delete(`/businesses/${businessId}/reserve`, token),

  getMyBusinesses: (token: string) =>
    apiClient.get('/scouts/me/businesses', token),
}
